import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "advanced-view-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "title is-size-4 has-text-weight-semibold has-first-letter-uppercase mb-2" }
const _hoisted_6 = { class: "header-subtitle" }
const _hoisted_7 = { class: "subtitle has-text-success" }
const _hoisted_8 = { class: "header-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-upload" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-television" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_station_export_modal = _resolveComponent("station-export-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('advanced_view.title')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title), 1 /* TEXT */)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_n_date_picker, {
        class: "mr-2",
        size: "large",
        type: "datetimerange",
        shortcuts: _ctx.shortcuts,
        "is-date-disabled": _ctx.isRangeDateDisabled,
        "onUpdate:value": _ctx.setDatetime,
        value: [_ctx.since.unix() * 1000 , _ctx.before.unix() * 1000]
      }, null, 8 /* PROPS */, ["shortcuts", "is-date-disabled", "onUpdate:value", "value"]),
      _createVNode(_component_n_button_group, {
        class: "mr-1",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('live'))),
            round: "",
            type: _ctx.mode === 'live' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('advanced_view.live')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"]),
          _createVNode(_component_n_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('hourly'))),
            round: "",
            type: _ctx.mode === 'hourly' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('advanced_view.hourly')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        class: "mr-1",
        round: "",
        size: "large",
        onClick: _ctx.refresh
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([{spin: _ctx.isLoading}, "mdi mdi-refresh"])
          }, null, 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_n_button, {
        class: "mr-1",
        size: "large",
        round: "",
        onClick: _ctx.exportStationData
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      (this.selected && this.selected.length && this.selected[0]?.pairing_token)
        ? (_openBlock(), _createBlock(_component_n_button, {
            key: 0,
            class: "mr-1",
            round: "",
            size: "large",
            href: _ctx.tvLink,
            tag: "a",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.selected && _ctx.selected.length)
      ? (_openBlock(), _createBlock(_component_station_export_modal, {
          key: 0,
          ref: "exportModal",
          station: _ctx.selected[0]
        }, null, 8 /* PROPS */, ["station"]))
      : _createCommentVNode("v-if", true)
  ]))
}